(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-description"] && !window.DesignMode) return;
  try {
    
  const link = document.querySelector('.iwd__button--anchor');
  if (link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const elementData = this.getAttribute('data-link');

      if (elementData != null) {
        const sectionToScroll = document?.querySelector(`naringenin-section[data-anchor='${elementData}']`);
        if (sectionToScroll) {
          let sectionToScrollTop = sectionToScroll.getBoundingClientRect().top + window.pageYOffset - 58;
          if (window.innerWidth < 767) {
            sectionToScrollTop = sectionToScroll.getBoundingClientRect().top + window.pageYOffset - 40;
          }

          if (sectionToScroll) {
            window.scrollTo({
              top: `${sectionToScrollTop}`,
              behavior: 'smooth'
            });
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('iwt-button')) {
  customElements.define('iwt-button', class IwtButton extends HTMLElement {
    constructor() {
      super();

      this.link = this.querySelector('.iwt__button--anchor');
      if (this.link) {
        this.link.addEventListener('click', function(e) {
          e.preventDefault();
          const elementData = this.getAttribute('data-link');

          if (elementData != null) {
            const sectionToScroll = document?.querySelector(`naringenin-section[data-anchor='${elementData}']`);
            if (sectionToScroll) {
              let sectionToScrollTop = sectionToScroll.getBoundingClientRect().top + window.pageYOffset - 58;
              if (window.innerWidth < 767) {
                sectionToScrollTop = sectionToScroll.getBoundingClientRect().top + window.pageYOffset - 40;
              }

              if (sectionToScroll) {
                window.scrollTo({
                  top: `${sectionToScrollTop}`,
                  behavior: 'smooth'
                });
              }
            }
          }
        });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
